import { supervisedAssuranceStart } from '@api/selfServiceServices';
import ContinueButton from '@components/continueButton/ContinueButton';
import { useErrorContext } from '@errorHandler/context/ErrorContext';
import { type ApiError, AppError } from '@errorHandler/errors';
import type { MutableRefObject } from 'react';
import { useTranslation } from 'react-i18next';
import ImprivataIdIcon from '../../../../assets/icons/authenticators/imprivata_ID.svg?react';
import ProxCardIcon from '../../../../assets/icons/authenticators/prox_card.svg?react';
import SuperviseIcon from '../../../../assets/icons/authenticators/supervise.svg?react';
import { EpcsSetupStep } from '../EpcsSetup';

interface StartAssuranceProps {
  authenticatorId: string;
  tenantId?: string;
  workflowId: string;
  assuranceIdRef: MutableRefObject<string>;
  setStep: (step: EpcsSetupStep) => void;
  cancelFlow: () => void;
}

const TRANSLATION = 'self-service.epcs-setup.start';

const EpcsStep1Start = ({
  authenticatorId,
  tenantId,
  workflowId,
  assuranceIdRef,
  setStep,
  cancelFlow,
}: StartAssuranceProps) => {
  const { t } = useTranslation();
  const { emitError } = useErrorContext();

  return (
    <div className="epcs-start continue-layout">
      <div>
        <h1 className="title">{t(`${TRANSLATION}.title`)}</h1>
        <p>{t(`${TRANSLATION}.instructions`)}</p>
        <div className="instruction-list">
          <div>
            <div>
              <SuperviseIcon />
            </div>
            <div>{t(`${TRANSLATION}.instruction-1`)}</div>
          </div>
          <div>
            <div>
              <ProxCardIcon />
            </div>
            <div>{t(`${TRANSLATION}.instruction-2`)}</div>
          </div>
          <div>
            <div>
              <ImprivataIdIcon />
            </div>
            <div>{t(`${TRANSLATION}.instruction-3`)}</div>
          </div>
        </div>
      </div>
      <div>
        <ContinueButton
          onClick={async () => {
            try {
              const res = await supervisedAssuranceStart({ authenticatorId }, workflowId, tenantId);
              assuranceIdRef.current = res?.assuranceId;
              setStep(EpcsSetupStep.STEP2_VERIFY_IDENTITY);
            } catch (error) {
              emitError(new AppError(error as ApiError));
            }
          }}
          secondaryButton={{ label: t('common.do-later'), onClick: cancelFlow }}
        >
          {t('common.continue-button')}
        </ContinueButton>
      </div>
    </div>
  );
};

export default EpcsStep1Start;
